"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const InfoLinkWithModal_1 = tslib_1.__importDefault(require("../ui/InfoLinkWithModal"));
const common_1 = require("../../../common");
const use_translation_wrapper_1 = require("../../../common/hooks/use-translation-wrapper");
const HostsDiscoveryTroubleshootingInfoLinkWithModal = ({ isInline = false, isSingleNode = false, }) => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (react_1.default.createElement(InfoLinkWithModal_1.default, { linkText: t('ai:Host not showing up?', { count: isSingleNode ? 1 : 2 }), modalTitle: t('ai:Hosts not showing up troubleshooter'), modalVariant: 'large', isInline: isInline, linkId: "link-host-troubleshooting", modalId: "modal-host-troubleshooting" },
        react_1.default.createElement(common_1.DiscoveryTroubleshootingModalContent, null)));
};
exports.default = HostsDiscoveryTroubleshootingInfoLinkWithModal;
//# sourceMappingURL=HostsDiscoveryTroubleshootingInfoLinkWithModal.js.map